import Head from 'next/head';
import Image from 'next/image';
import type { FC } from 'react';
import { Chip, Container } from '@/DesignSystem/Component';
import { FILE_BROWSER_URL } from '@/Module/Core/Constant';
import { preparePageTitle } from '@/Module/Core/Helper';
const ApplicationNotFound: FC = () => {
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="ApplicationNotFound.tsx">
        <title>{preparePageTitle('صفحه پیدا نشد')}</title>
        <meta name="robots" content="noindex, nofollow" data-sentry-element="meta" data-sentry-source-file="ApplicationNotFound.tsx" />
      </Head>
      <section className="bg-error-page bg-cover bg-no-repeat py-16 md:h-screen md:py-0">
        <Container data-sentry-element="Container" data-sentry-source-file="ApplicationNotFound.tsx">
          <div className="flex flex-col items-stretch gap-16 md:h-screen md:flex-row md:gap-10">
            <div className="flex flex-1 items-stretch justify-center md:justify-end md:gap-12">
              <div className="-ml-16 flex flex-col items-center justify-start md:ml-0 md:justify-center">
                <Image src={`${FILE_BROWSER_URL}/img/img-404-page-icon.svg`} className="mt-4 w-[47px] md:mt-0 md:min-w-[88px]" alt="صفحه پیدا نشد" width={88} height={89} data-sentry-element="Image" data-sentry-source-file="ApplicationNotFound.tsx" />
              </div>
              <div className="flex flex-col items-end justify-center">
                <span className="font-mono text-7xl font-bold text-redFour drop-shadow-errorText lg:text-9xl">404</span>
                <span className="mb-8 font-mono text-7xl font-bold text-redFour drop-shadow-errorText lg:text-9xl">
                  Error
                </span>
                <Chip title="صفحه پیدا نشد." color="white" bold data-sentry-element="Chip" data-sentry-source-file="ApplicationNotFound.tsx" />
              </div>
            </div>
            <div className="flex flex-1 items-center justify-center md:justify-start">
              <div className="relative inline-flex">
                <span className="absolute bottom-full right-0 inline-flex h-[114px] w-[242px] translate-y-2/3 items-center justify-center bg-error-quotation bg-contain bg-center bg-no-repeat pb-[16px] text-lg font-black text-redFour md:left-2/3 md:right-auto xl:h-[155px] xl:w-[372px] xl:pb-[32px] xl:text-2xl">
                  گشتم نبود؛ نگرد نیست!
                </span>
                <Image src={`${FILE_BROWSER_URL}/img/img-404-page-person.svg`} className=" max-w-[80%] " alt="صفحه پیدا نشد" width={442} height={465} data-sentry-element="Image" data-sentry-source-file="ApplicationNotFound.tsx" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>;
};
export default ApplicationNotFound;